var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginalBgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 528.57 429.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#linear-gradient-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        stroke: url(#linear-gradient-9);\n      }\n\n      .cls-4 {\n        stroke: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        stroke: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        stroke: url(#linear-gradient-13);\n      }\n\n      .cls-7 {\n        stroke: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        stroke: url(#linear-gradient-12);\n      }\n\n      .cls-9 {\n        stroke: url(#linear-gradient-5);\n      }\n\n      .cls-10 {\n        opacity: .5;\n      }\n\n      .cls-11 {\n        stroke: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        stroke: url(#linear-gradient-14);\n      }\n\n      .cls-13 {\n        stroke: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        stroke: url(#linear-gradient-8);\n      }\n\n      .cls-15 {\n        stroke: url(#linear-gradient-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 349.01,
    y1: 633.77,
    x2: 349.01,
    y2: 435.99,
    gradientTransform: "translate(-209.97 -344.54) rotate(5.09) scale(1.49 1.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f4e933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e9e63c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d6e04c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#bcd762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9acc7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#71bfa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#41b0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3390d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4e5cad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5e3c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 349.29,
    y1: 622.49,
    x2: 349.29,
    y2: 424.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 349.57,
    y1: 611.21,
    x2: 349.57,
    y2: 413.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 349.85,
    y1: 599.93,
    x2: 349.85,
    y2: 402.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 350.13,
    y1: 588.65,
    x2: 350.13,
    y2: 390.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 350.41,
    y1: 577.37,
    x2: 350.41,
    y2: 379.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 350.69,
    y1: 566.09,
    x2: 350.69,
    y2: 368.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 350.96,
    y1: 554.81,
    x2: 350.96,
    y2: 357.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 351.24,
    y1: 543.53,
    x2: 351.24,
    y2: 345.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 351.52,
    y1: 532.25,
    x2: 351.52,
    y2: 334.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 351.8,
    y1: 520.97,
    x2: 351.8,
    y2: 323.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 352.08,
    y1: 509.69,
    x2: 352.08,
    y2: 311.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 352.36,
    y1: 498.41,
    x2: 352.36,
    y2: 300.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 352.64,
    y1: 487.13,
    x2: 352.64,
    y2: 289.35,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1.18,162.54c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.71,150.04c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.24,137.55c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.77,125.05c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m7.3,112.56c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.83,100.06c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.36,87.57c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m11.89,75.07c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m13.43,62.58c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m14.96,50.09c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.49,37.59c-20.47,94.21,427.9,240.55,507.34,266.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m18.02,25.1C-2.45,119.31,445.92,265.64,525.36,291.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m19.55,12.6C-.92,106.81,447.45,253.15,526.89,278.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m21.08.11C.61,94.32,448.98,240.65,528.42,266.19"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalBgImg3);
export default __webpack_public_path__ + "static/media/original-bg-img-3.fbdeabd87213960148da2c28481cec73.svg";
export { ForwardRef as ReactComponent };